<template>
  <div class="medialib">
    <div class="medialib__header">
      <h2 class="medium-title">Media Library</h2>
    </div>
    <div class="medalib__list">
      <adx-media 
        ref="media"
        :display="display"
      />
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Media from '@/views/Media'

export default {
  name: 'adx-dashboard-media-library',
  components: {
    'adx-modal': Modal,
    'adx-media': Media
  },
  props: {
    
  },
  data() {
    return {
      display: 'grid',
      modalUpload: false,
    }
  },
  computed: {

  },
  watch: {
    
  },
  beforeCreate() {

  },
  created() {
    
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.filter-dropdown, .sorting-dropdown {
  .btn-regular {
    padding: 8px;
  }
}
</style>

